export const RATING_FORMULA_LABEL = "Sabor 50% · Servicio 20% · Satisfacción 30%";

export const isPublishedRatingReview = review => !review?.pending && !review?.metadata?.rejected;
export const isEditorialRatingReview = review => String(review?.userid || review?.userId || "").toLowerCase() === "venaqqi";

export const averageRatingDimension = (reviews, field) => {
  const values = (Array.isArray(reviews) ? reviews : [])
    .map(review => Number(review?.[field]))
    .filter(Number.isFinite);
  if (!values.length) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

export const qualityRatingScore = reviews => {
  const list = Array.isArray(reviews) ? reviews : [];
  if (!list.length) return 0;
  return averageRatingDimension(list, "sabor") * 0.5
    + averageRatingDimension(list, "servicio") * 0.2
    + averageRatingDimension(list, "satisfaccion") * 0.3;
};

const group = (source, reviews) => ({
  source,
  reviews,
  count: reviews.length,
  score: qualityRatingScore(reviews),
});

export const buildRatingSummary = reviews => {
  const published = (Array.isArray(reviews) ? reviews : []).filter(isPublishedRatingReview);
  const editorialReviews = published.filter(isEditorialRatingReview);
  const communityReviews = published.filter(review => !isEditorialRatingReview(review));
  const community = group("usuarios", communityReviews);
  const editorial = group("venaqqi", editorialReviews);
  const display = community.count ? community : editorial;
  return { published, community, editorial, display };
};
